import arrayConcat from './images/Array-Concatenate.svg';
import arrayDoubles from './images/Array-RemoveDoubleInt.svg';
import removeDoubles from './images/removeDoubles.png';
import sumVals from './images/Array-SumVals.svg';
import fibonacci from './images/fibonacci.svg';
import fizzbuzz from './images/fizzbuzz.svg';
import isPrime from './images/isPrime.jpg';
import palindrome from './images/palindrome.svg';
import primeFactors from './images/primeFactors.svg';
import revstr from './images/StrRev.svg';
import revnum from './images/reversedNum.svg';
import vowels from './images/vowels.svg';
import vowels2 from './images/vowels-norgx.svg';

export const Data = [
    {
        id: 11,
        title: "FizzBuzz",
        image: fizzbuzz,
        task: "Print integers 1 to N, but print 'Fizz' if an integer is divisible by 3, 'Buzz' if an integer is divisible by 5, and 'FizzBuzz' if an integer is divisible by both 3 and 5.",
        view: "view",
        code: "FizzBuzz Editor"
    },
    {
        id: 12,
        title: "IsPrime",
        image: isPrime,
        task: "Check if a number is a prime number (a natural number greater than 1, that can only be divided equally by 1 and itself).",
        view: "view",
        code: "IsPrime Editor"
    },
    {
        id: 14,
        title: "String Reverse",
        image: revstr,
        task: "Reverse the string being input.",
        view: "View",
        code: "String Rev Editor"
    },
    {
        id: 15,
        title: "Palindrome",
        image: palindrome,
        task: "Check if input is a palindrome (words, phrases or numbers that read the same forwards and backwards).",
        view: "View",
        code: "Palindrome Editor"
    },
    {
        id: 16,
        title: "Reverse Numbers",
        image: revnum,
        task: "Reverse the numbers being input.",
        view: "View",
        code: "Integer Rev Editor"
    },
    {
        id: 17,
        title: "Prime Factors",
        image: primeFactors,
        task: "Find all prime factors of a number.",
        view: "View",
        code: "Max Char Editor"
    },
    {
        id: 19,
        title: "Vowels -Number Of (with regex)",
        image: vowels,
        task: "Using regex, Write a function that returns the number of vowels used in a string. Vowels are the characters 'a', 'e' 'i', 'o', and 'u'.",
        view: "View",
        code: "Vowels Editor"
    },
    {
        id: 20,
        title: "Fibonacci",
        image: fibonacci,
        task: "Get nth Fibonacci number.",
        view: "View",
        code: "Array Editor"
    },
    {
        id: 21,
        title: "Remove Double Int",
        image: arrayDoubles,
        task: "Sort and remove double integers from an array.",
        view: "View",
        code: "Array Editor"
    },
    {
        id: 22,
        title: "Remove Double Str",
        image: removeDoubles,
        task: "Remove double strings from an array",
        view: "View",
        code: "Array Editor"
    },
    {
        id: 23,
        title: "Array - Summarize Ints",
        image: sumVals,
        task: "Summarize the integers in an array",
        view: "View",
        code: "Array Editor"
    },
    {
        id: 24,
        title: "Concatenate Strings",
        image: arrayConcat,
        task: "Concatenate two arrays.",
        view: "View",
        code: "Array Editor"
    },
    {
        id: 25,
        title: "Vowels -Number Of (no regex)",
        image: vowels2,
        task: "Do NOT use regex. Write a function that returns the number of vowels used in a string. Vowels are the characters 'a', 'e' 'i', 'o', and 'u'.",
        view: "View",
        code: "Vowels Editor"
    }

]